import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { ContentProvider } from "@/lib/ContentContext";
import { PwaProvider } from "@/lib/pwa";
import { SiteLayout } from "@/components/site/SiteLayout";
import { UpdateBanner } from "@/components/site/PwaBits";

import Home from "@/pages/Home";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import Residential from "@/pages/Residential";
import Commercial from "@/pages/Commercial";
import BeforeAfterPage from "@/pages/BeforeAfterPage";
import About from "@/pages/About";
import Reviews from "@/pages/Reviews";
import LeaveReview from "@/pages/LeaveReview";
import ReviewRequest from "@/pages/ReviewRequest";
import ServiceAreas from "@/pages/ServiceAreas";
import FAQ from "@/pages/FAQ";
import Contact from "@/pages/Contact";
import GetQuote from "@/pages/GetQuote";
import QuoteConfirmation from "@/pages/QuoteConfirmation";
import Legal from "@/pages/Legal";
import FinancingPage from "@/pages/FinancingPage";
import ClientInvoice from "@/pages/ClientInvoice";
import NotFound from "@/pages/NotFound";

import AdminLogin from "@/admin/Login";
import AdminApp from "@/admin/AdminApp";

const Site = ({ children }) => <SiteLayout>{children}</SiteLayout>;

function App() {
  return (
    <ContentProvider>
      <PwaProvider>
      <Toaster position="top-center" richColors />
      <BrowserRouter>
        <UpdateBanner />
        <Routes>
          <Route path="/" element={<Site><Home /></Site>} />
          <Route path="/services" element={<Site><Services /></Site>} />
          <Route path="/services/:slug" element={<Site><ServiceDetail /></Site>} />
          <Route path="/residential" element={<Site><Residential /></Site>} />
          <Route path="/commercial" element={<Site><Commercial /></Site>} />
          <Route path="/before-after" element={<Site><BeforeAfterPage /></Site>} />
          <Route path="/about" element={<Site><About /></Site>} />
          <Route path="/reviews" element={<Site><Reviews /></Site>} />
          <Route path="/reviews/leave" element={<Site><LeaveReview /></Site>} />
          <Route path="/review/:token" element={<Site><ReviewRequest /></Site>} />
          <Route path="/service-areas" element={<Site><ServiceAreas /></Site>} />
          <Route path="/faq" element={<Site><FAQ /></Site>} />
          <Route path="/contact" element={<Site><Contact /></Site>} />
          <Route path="/get-a-quote" element={<Site><GetQuote /></Site>} />
          <Route path="/quote-confirmation" element={<Site><QuoteConfirmation /></Site>} />
          <Route path="/privacy" element={<Site><Legal type="privacy" /></Site>} />
          <Route path="/terms" element={<Site><Legal type="terms" /></Site>} />
          <Route path="/accessibility" element={<Site><Legal type="accessibility" /></Site>} />
          <Route path="/financing" element={<Site><FinancingPage /></Site>} />

          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/*" element={<AdminApp />} />

          <Route path="/invoice/:token" element={<ClientInvoice />} />

          <Route path="*" element={<Site><NotFound /></Site>} />
        </Routes>
      </BrowserRouter>
      </PwaProvider>
    </ContentProvider>
  );
}

export default App;
